"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledInput = exports.StyleBase = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var colors = _interopRequireWildcard(require("../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyleBase = _styledComponents["default"].div.withConfig({
  displayName: "StyleBase",
  componentId: "sc-1n3upm8-0"
})([""]);

exports.StyleBase = StyleBase;

var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "StyledInput",
  componentId: "sc-1n3upm8-1"
})(["position:absolute;opacity:0;&:hover + label:before{border-color:", ";}&:checked + label:before{background:", ";border-color:", ";}&:disabled + label{color:", ";cursor:auto;}&:disabled + label:before{box-shadow:none;border-color:", ";background:", ";}&:checked + label:after{content:'';position:absolute;left:4px;top:8px;background:white;width:2px;height:2px;box-shadow:2px 0 0 white,4px 0 0 white,4px -2px 0 white,4px -4px 0 white,4px -6px 0 white,4px -8px 0 white;transform:rotate(45deg);}"], colors.titleColor, colors.primary, colors.primary, colors.textColor, colors.textColor, colors.textColor);

exports.StyledInput = StyledInput;

var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-1n3upm8-2"
})(["position:relative;cursor:pointer;padding:0;color:", ";font-size:14px;font-family:'Roboto',sans-serif;font-weight:500;&:before{content:'';margin-right:10px;display:inline-block;vertical-align:text-top;width:14px;height:14px;border-radius:2px;border:2px solid ", ";}"], colors.titleColor, colors.textColor);

exports.StyledLabel = StyledLabel;